<template>
  <el-dialog
    v-dialogDrag
    v-dialogResize
    custom-class="waterproof-view-dialog"
    title="查看防水商户报单（可拖拽）"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    append-to-body
    @open="handleOpen"
    @closed="handleClosed"
  >
    <div class="container" v-loading="loading">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>防水商户报单信息:</span>
        </div>
        <div class="card-content">
          <el-row :gutter="20">
            <el-col v-for="(item) in column" :key="item.prop" :span="8" :class="{ 'full-width': item.prop === 'remarks' }">
              <div class="form-group">
                <label class="label">{{ item.label }}:</label>
                <span class="content">{{ formatValue(item, info[item.prop]) }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <el-card v-if="selectedGoods.length > 0" shadow="hover" class="card mt-20">
        <div slot="header" class="clearfix">
          <span class="card-title">商品列表</span>
        </div>
        <div class="card-content">
          <el-table :data="selectedGoods" style="width: 100%" border>
            <el-table-column prop="goodsName" label="商品名称"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="small" @click="handleClose" icon="el-icon-circle-close-outline">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getGoodList, getMerchantOrder } from "@/api/work/waterProject/merchants";
import { formatterTime, formatterDate } from "@/util/util";

export default {
  name: 'WaterProofMerchantView',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  directives: {
    // el-dialog 可拖拽指令：按住头部拖动，限制在视口内
    dialogDrag: {
      bind(el) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        if (!dialogHeaderEl || !dragDom) return;

        dialogHeaderEl.onmousedown = (e) => {
          // 首次拖拽前，将弹窗转为绝对定位并保留当前视觉位置（初始为 flex 居中）
          if (dragDom.style.position !== 'absolute') {
            const rect = dragDom.getBoundingClientRect();
            dragDom.style.position = 'absolute';
            dragDom.style.margin = '0';
            dragDom.style.left = rect.left + 'px';
            dragDom.style.top = rect.top + 'px';
          }
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;
          const dragDomWidth = dragDom.offsetWidth;
          const dragDomHeight = dragDom.offsetHeight;
          const screenWidth = document.documentElement.clientWidth;
          const screenHeight = document.documentElement.clientHeight;
          const minDragDomLeft = dragDom.offsetLeft;
          const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
          const minDragDomTop = dragDom.offsetTop;
          const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
          const styL = getComputedStyle(dragDom).left;
          const styT = getComputedStyle(dragDom).top;
          let left = styL.includes('%')
            ? +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
            : +styL.replace(/px/g, '');
          let top = styT.includes('%')
            ? +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
            : +styT.replace(/px/g, '');

          document.onmousemove = (ev) => {
            let moveLeft = ev.clientX - disX;
            let moveTop = ev.clientY - disY;
            if (-moveLeft > minDragDomLeft) moveLeft = -minDragDomLeft;
            else if (moveLeft > maxDragDomLeft) moveLeft = maxDragDomLeft;
            if (-moveTop > minDragDomTop) moveTop = -minDragDomTop;
            else if (moveTop > maxDragDomTop) moveTop = maxDragDomTop;
            dragDom.style.cssText += `;left:${moveLeft + left}px;top:${moveTop + top}px;`;
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
    // el-dialog 可缩放指令：鼠标移到边缘/四角时拖拽改变尺寸
    dialogResize: {
      bind(el) {
        const dragDom = el.querySelector('.el-dialog');
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        if (!dragDom) return;
        const EDGE = 8;
        const cursorMap = {
          top: 'ns-resize',
          bottom: 'ns-resize',
          left: 'ew-resize',
          right: 'ew-resize',
          'top-left': 'nwse-resize',
          'bottom-right': 'nwse-resize',
          'top-right': 'nesw-resize',
          'bottom-left': 'nesw-resize',
        };
        const getDirection = (e) => {
          const rect = dragDom.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          if (x < 0 || y < 0 || x > rect.width || y > rect.height) return '';
          const top = y < EDGE;
          const bottom = y > rect.height - EDGE;
          const left = x < EDGE;
          const right = x > rect.width - EDGE;
          if (top && left) return 'top-left';
          if (top && right) return 'top-right';
          if (bottom && left) return 'bottom-left';
          if (bottom && right) return 'bottom-right';
          if (top) return 'top';
          if (bottom) return 'bottom';
          if (left) return 'left';
          if (right) return 'right';
          return '';
        };

        dragDom.addEventListener('mousemove', (e) => {
          if (document._isDialogResizing) return;
          const dir = getDirection(e);
          if (dir) {
            dragDom.style.cursor = cursorMap[dir];
            if (dialogHeaderEl) dialogHeaderEl.style.cursor = cursorMap[dir];
          } else if (dialogHeaderEl && dialogHeaderEl.contains(e.target)) {
            dialogHeaderEl.style.cursor = 'move';
            dragDom.style.cursor = '';
          } else {
            dragDom.style.cursor = '';
            if (dialogHeaderEl) dialogHeaderEl.style.cursor = '';
          }
        });

        dragDom.addEventListener(
          'mousedown',
          (e) => {
            const dir = getDirection(e);
            if (!dir) return;
            e.stopPropagation();
            e.preventDefault();
            document._isDialogResizing = true;
            const rect = dragDom.getBoundingClientRect();
            if (dragDom.style.position !== 'absolute') {
              dragDom.style.position = 'absolute';
              dragDom.style.margin = '0';
              dragDom.style.left = rect.left + 'px';
              dragDom.style.top = rect.top + 'px';
            }
            const startX = e.clientX;
            const startY = e.clientY;
            const startW = rect.width;
            const startH = rect.height;
            const startL = rect.left;
            const startT = rect.top;
            const minW = 320;
            const minH = 200;
            const screenW = document.documentElement.clientWidth;
            const screenH = document.documentElement.clientHeight;

            document.onmousemove = (ev) => {
              const dx = ev.clientX - startX;
              const dy = ev.clientY - startY;
              let newW = startW;
              let newH = startH;
              let newL = startL;
              let newT = startT;
              if (dir.indexOf('right') >= 0) {
                newW = Math.max(minW, Math.min(startW + dx, screenW - startL));
              }
              if (dir.indexOf('bottom') >= 0) {
                newH = Math.max(minH, Math.min(startH + dy, screenH - startT));
              }
              if (dir.indexOf('left') >= 0) {
                newW = Math.max(minW, Math.min(startW - dx, startL + startW));
                newL = startL + (startW - newW);
              }
              if (dir.indexOf('top') >= 0) {
                newH = Math.max(minH, Math.min(startH - dy, startT + startH));
                newT = startT + (startH - newH);
              }
              dragDom.style.width = newW + 'px';
              dragDom.style.height = newH + 'px';
              dragDom.style.left = newL + 'px';
              dragDom.style.top = newT + 'px';
            };
            document.onmouseup = () => {
              document._isDialogResizing = false;
              document.onmousemove = null;
              document.onmouseup = null;
            };
          },
          true
        );
      },
    },
  },
  data() {
    return {
      loading: false,
      info: {},
      goodsList: [],
      selectedGoods: [],
      column: [
        { label: "报单商家名称", prop: "shopName" },
        { label: "报单商家电话", prop: "shopMobile" },
        { label: "销售部门", prop: "region" },
        { label: "施工地址(区/县)", prop: "customAddress" },
        { label: "工地联系人姓名", prop: "contactName" },
        { label: "工地联系人电话", prop: "contactMobile" },
        { label: "付款人姓名", prop: "customName" },
        { label: "付款人电话", prop: "customMobile" },
        { label: "施工项目套餐", prop: "comboName" },
        { label: "房屋类型", prop: "buildingType" },
        { label: "预约人类型", prop: "appointmentType" },
        { label: "户型信息", prop: "houseType" },
        { label: "是否回填", prop: "backFill" },
        { label: "回填坑位数量", prop: "voucher" },
        { label: "涂料颜色", prop: "paintType" },
        { label: "服务类型", prop: "serviceType" },
        { label: "保护层类型", prop: "protectLayerType" },
        { label: "质保人姓名", prop: "warrantyName" },
        { label: "质保人电话", prop: "payee" },
        { label: "预付款", prop: "advanceCharge" },
        { label: "装饰公司/商家名称", prop: "paymentTarget" },
        { label: "业务员", prop: "introducer" },
        { label: "预计进场时间", prop: "entranceTime", type: "dateTime" },
        { label: "报单日期", prop: "declarationDate", type: "dateTime" },
        { label: "备注", prop: "remarks" }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleOpen() {
      this.initData();
      this.$nextTick(() => {
        // 弹窗水平垂直居中：给外层 wrapper 套 flex
        const dialog = document.querySelector('.waterproof-view-dialog');
        if (dialog) {
          const wrapper = dialog.parentElement;
          if (wrapper && wrapper.classList.contains('el-dialog__wrapper')) {
            wrapper.style.display = 'flex';
            wrapper.style.alignItems = 'center';
            wrapper.style.justifyContent = 'center';
          }
          // 重置弹窗位置状态（避免上次拖拽/缩放遗留的 inline style 影响居中）
          dialog.style.position = '';
          dialog.style.left = '';
          dialog.style.top = '';
          dialog.style.margin = '0';
          dialog.style.width = '';
          dialog.style.height = '';
          dialog.style.cursor = '';
        }
        // 蒙层透明度调为 0.1，方便连同后面的列表一起截图
        const modal = document.querySelector('.v-modal');
        if (modal) {
          this._originalModalOpacity = modal.style.opacity;
          modal.style.opacity = '0.1';
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClosed() {
      // 弹窗完全关闭后恢复蒙层透明度
      const modal = document.querySelector('.v-modal');
      if (modal) {
        modal.style.opacity = this._originalModalOpacity || '';
      }
    },
    async initData() {
      const id = this.id;
      this.info = {};
      this.selectedGoods = [];
      if (!id) return;
      try {
        this.loading = true;
        const res = await getMerchantOrder(id);
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = this.formatData(data);
          getGoodList(id).then(res => {
            if (res.code === '200') {
              let selectedGoods = JSON.parse(res.data);
              this.selectedGoods = selectedGoods.map(item => ({
                ...item,
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId,
                declarationId: item.declarationId,
              }));
            }
          });
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    formatData(data) {
      if (!data) return {};
      return {
        ...data,
        entranceTime: data.entranceTime ? formatterTime(data.entranceTime) : '',
        declarationDate: data.declarationDate ? formatterDate(data.declarationDate) : ''
      };
    },
    formatValue(item, value) {
      if (!value) return '--';
      return value;
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .card {
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .form-group {
    margin: 15px 0;
    display: flex;
    align-items: flex-start;

    .label {
      width: 120px;
      font-weight: 500;
      color: #606266;
    }

    .content {
      flex: 1;
      color: #303133;
    }
  }

  .mt-20 {
    margin-top: 20px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
  }

  .full-width {
    width: 100%;
  }

  .card-content {
    padding: 10px;
  }
}
</style>

<style>
/* 限制弹窗最大高度，避免内容撑高超出视口。并使 body 内部滚动 */
.waterproof-view-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.waterproof-view-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
